export type LegacyErrorResponse = {
  message: string;
  status: number;
  statusCode?: number; //FIXME: the timesheet API is using statusCode instead of status
};

export type Problem = {
  type: string;
  title: string;
  detail?: string;
  metadata?: Record<string, unknown>;
};

export type ErrorResponse = {
  type: string;
  title: string;
  status: number;
  detail?: string;
  instance?: string;
  traceId?: string;
  problems?: Problem[];
  metadata?: Record<string, unknown>;
  docs?: string;
};

export const isLegacyErrorResponse = (
  error: ErrorResponse | LegacyErrorResponse,
): error is LegacyErrorResponse => {
  return (error as LegacyErrorResponse).message !== undefined;
};

export const isErrorResponse = (
  error: ErrorResponse | LegacyErrorResponse,
): error is ErrorResponse => {
  return (error as ErrorResponse).title !== undefined;
};

export type FieldPermissionsAPI = {
  name: string;
  is_editable: boolean;
  reason_is_not_editable?: string;
};

export type ResourcePermissionsAPI = {
  is_editable: boolean;
  is_archivable: boolean;
  reason_is_not_editable?: string;
  reason_is_not_archivable?: string;
  fields: FieldPermissionsAPI[];
};

export type FieldPermissions = {
  name: string;
  isEditable: boolean;
  reasonIsNotEditable?: string;
};

export type ResourcePermissions = {
  isEditable: boolean;
  isArchivable: boolean;
  reasonIsNotEditable?: string;
  reasonIsNotArchivable?: string;
  fields: FieldPermissions[];
};
